export default "__VITE_ASSET__C0lr_I8v__"